// src/config/index.ts
// 環境に応じた設定を提供する設定ファイル

// 環境の判定
const isProduction = import.meta.env.MODE === 'production';
const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';

// 開発環境と本番環境のFunctionsのURLを定義
const devFunctionUrls = {
  sendVerificationCode: 'https://sendverificationcode-ojhpakvq6q-an.a.run.app',
  verifyCode: 'https://verifycode-ojhpakvq6q-an.a.run.app',
};

// 本番環境のFunctionsのURL
const prodFunctionUrls = {
  sendVerificationCode: 'https://sendverificationcode-sr2ykfoz6q-an.a.run.app',
  verifyCode: 'https://verifycode-sr2ykfoz6q-an.a.run.app',
};

// Figryne Backend API URLs
const localApiUrl = 'http://localhost:8000';
const devApiUrl = 'https://devapi.figryne.com';
const prodApiUrl = 'https://api.figryne.com';

// API URLを環境に応じて選択
const getApiBaseUrl = () => {
  if (isLocalhost) return localApiUrl;
  if (isProduction) return prodApiUrl;
  return devApiUrl;
};

// appeear.me URLs
const localAppeearMeUrl = 'http://localhost:5176';
const devAppeearMeUrl = 'https://dev.appeear.me';
const prodAppeearMeUrl = 'https://appeear.me';

// appeear.me URL を環境に応じて選択
const getAppeearMeUrl = () => {
  if (isLocalhost) return localAppeearMeUrl;
  if (isProduction) return prodAppeearMeUrl;
  return devAppeearMeUrl;
};

// Figryne URLs
const localFigryneUrl = 'http://localhost:5173';
const devFigryneUrl = 'https://dev.figryne.com';
const prodFigryneUrl = 'https://figryne.com';

// Figryne URL を環境に応じて選択
const getFigryneUrl = () => {
  if (isLocalhost) return localFigryneUrl;
  if (isProduction) return prodFigryneUrl;
  return devFigryneUrl;
};

// 環境に応じた設定をエクスポート
export const config = {
  functionUrls: isProduction ? prodFunctionUrls : devFunctionUrls,
  apiBaseUrl: getApiBaseUrl(),
  appeearMeUrl: getAppeearMeUrl(),
  figryneUrl: getFigryneUrl(),
  // CDNは本番環境のみ使用（dev/localではGCS署名付きURLを直接使用）
  useCdn: isProduction,
};

// デバッグ用（本番では無効化）
// console.log(`Running in ${isProduction ? 'production' : 'development'} mode`);
// console.log(`API Base URL: ${config.apiBaseUrl}`);
// console.log(`appeear.me URL: ${config.appeearMeUrl}`);
